import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Announcements from "@/pages/Announcements";
import WorkOrders from "@/pages/WorkOrders";
import Violations from "@/pages/Violations";
import Dues from "@/pages/Dues";
import Meetings from "@/pages/Meetings";
import Documents from "@/pages/Documents";
import Directory from "@/pages/Directory";
import Polls from "@/pages/Polls";
import LiveVote from "@/pages/LiveVote";
import BroadcastVote from "@/pages/BroadcastVote";
import Advocacy from "@/pages/Advocacy";
import Pricing from "@/pages/Pricing";
import Subscription from "@/pages/Subscription";
import AISaint from "@/pages/AISaint";
import LegalSuite from "@/pages/LegalSuite";
import FinancialReports from "@/pages/FinancialReports";
import CommunityHub from "@/pages/CommunityHub";
import BoardOps from "@/pages/BoardOps";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Delinquency from "@/pages/Delinquency";
import CollectionsPolicy from "@/pages/CollectionsPolicy";
import WorkOrderDetail from "@/pages/WorkOrderDetail";
import Impact from "@/pages/Impact";
import MyBalance from "@/pages/MyBalance";
import Inquiries from "@/pages/Inquiries";
import { Toaster } from "@/components/ui/sonner";

function Root() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }
  return user ? <Navigate to="/dashboard" replace /> : <Landing />;
}

const app = (El) => (
  <ProtectedRoute>
    <Layout>
      <El />
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={app(Dashboard)} />
          <Route path="/announcements" element={app(Announcements)} />
          <Route path="/work-orders" element={app(WorkOrders)} />
          <Route path="/violations" element={app(Violations)} />
          <Route path="/dues" element={app(Dues)} />
          <Route path="/meetings" element={app(Meetings)} />
          <Route path="/documents" element={app(Documents)} />
          <Route path="/directory" element={app(Directory)} />
          <Route path="/polls" element={app(Polls)} />
          <Route path="/live-vote" element={app(LiveVote)} />
          <Route path="/advocacy" element={app(Advocacy)} />
          <Route path="/subscription" element={app(Subscription)} />
          <Route path="/legal-suite" element={app(LegalSuite)} />
          <Route path="/ai-saint" element={app(AISaint)} />
          <Route path="/financial-reports" element={app(FinancialReports)} />
          <Route path="/community" element={app(CommunityHub)} />
          <Route path="/board-ops" element={app(BoardOps)} />
          <Route path="/delinquency" element={app(Delinquency)} />
          <Route path="/collections-policy" element={app(CollectionsPolicy)} />
          <Route path="/work-orders/:wid" element={app(WorkOrderDetail)} />
          <Route path="/my-balance" element={app(MyBalance)} />
          <Route path="/documents" element={app(Documents)} />
          <Route path="/inquiries" element={app(Inquiries)} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/vote/broadcast/:id" element={<BroadcastVote />} />
          <Route path="/payment/success" element={app(PaymentSuccess)} />
          <Route path="/payment/cancel" element={app(PaymentCancel)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
